import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { ConfigContext } from "./ConfigContext";
import { toast } from "react-toastify";
import { axiosGet, axiosPost } from "../Apis/axiosMethods";

export const CartsContext = createContext();

export const CartsProvider = ({ children }) => {

    const {
        apiB2BURL,
        business_id,
        apiHeaderJson,
        business_user_id,
        isCartUpdate,
        business_type,
        setIsCartUpdate,
        setFavItemsQty,
        setFavItems,
        setIsFavUpdate,
        isFavUpdate,
        FavItems,
        business_delivery_days,
        vat_amount

    } = useContext(ConfigContext);

    const headers = apiHeaderJson;

    const [cartLoading, setCartLoading] = useState(true);
    const [cartData, setData] = useState(null)

    const [cartItems, setCartItems] = useState([]);
    const [loadings, setLoading] = useState(false);

    const [sub_total_display, setSubTotalDisplay] = useState(0);
    const [vat_amount_display, setVatAmountDisplay] = useState(0);

    const [coupon, setCoupon] = useState(localStorage.getItem("coupon"));

    const AddToCart = async (data, qty, item_img_url, item_url, sale_type) => {
        try {
            setLoading(true);

            const price = Number(
                business_type === 1
                    ? (data?.VD_BG_PRICE || data?.stock_bg_price)
                    : (data?.VD_BB_PRICE || data?.stock_bb_price || data?.VD_PRICE)
            ) || 0;

            const vatAmount = (price * qty * vat_amount) / 100;


            const payload = {
                item_id: data?.ART_ID ?? data?.item_id ?? 0,
                item_number: data?.ART_SEARCH_NUMBER || data?.ART_ARTICLE_NR || data?.item_number || data?.stock_number,
                item_title: data?.PRODUCT_GROUP_EN ?? data?.item_title ?? data?.product_name ?? data?.ART_PRODUCT_NAME,
                item_mrp: data?.stock_price_mrp,
                item_price: price,
                item_qty: qty,
                item_img_url,
                item_url,
                max_qty: data?.VD_QTY || data?.stock_available_qty,
                item_sup_id: data?.ART_SUP_ID,
                business_cart_item_sub_total: price * qty,
                business_cart_item_brand: sale_type === "oil" ? data?.stock_brand_name : data?.ART_SUP_BRAND ?? data?.stock_brand_name,
                business_cart_item_store_id: data?.inventory_store_id,
                stock_oe: sale_type === "oil" ? data?.stock_type : data?.stock_oe,
                stock_delivery_days: business_delivery_days + data?.stock_delivery_days,
                sale_type,
                vat_amount: vatAmount
            }

            const response = await axiosPost(`/Orders/AddToCart`, payload, { headers })
            if (response?.data?.success) {
                setIsCartUpdate(prev => !prev)
            }
        } catch (error) {
            console.error("AddToCart error:", error);
            return { success: false };
        } finally {
            setLoading(false);
        }
    }

    const GetCartsData = async () => {
        try {
            setCartLoading(true);
            const response = await axiosGet(`/Orders/GetExcludeVatCarts`, {
                business_type,
                currency: localStorage.getItem('currency') ?? 'aed',
                lang: "en",
                business_id,
                business_user_id,
                coupon: coupon,
            })

            if (response?.data?.success) {
                const data = response?.data?.data;
                setData(data);
                setCartItems(data?.items);
                setSubTotalDisplay(data?.sub_total_display);
                setVatAmountDisplay(data?.vat_amount_display);

            }

        } catch (error) {
            console.log(error)
        } finally {
            setCartLoading(false);
        }
    }

    const QtyUpdate = async (item_uid, qty) => {
        try {
            const payload = {
                business_id,
                item_uid,
                new_qty: qty
            };

            const response = await axiosPost(`/Orders/UpdateCartQty`, payload);
            if (response?.data?.success) {
                setIsCartUpdate(prev => !prev)
            }

        } catch (error) {
            console.log("QtyUpdate Error", error);
        }
    };

    const DeleteCartItem = async (item_uid) => {
        try {
            const payload = {
                business_id,
                item_uid
            }

            const response = await axiosPost(`/Orders/RemoveCart`, payload);
            if (response?.data?.success) {
                setIsCartUpdate(prev => !prev)
            }

        } catch (error) {
            console.log("error", error)
        } finally {
        }
    }

    const GetCartItemQty = async (item_number) => {
        try {

            const response = await axiosGet(`/Orders/GetExcludeVatCarts`, {
                currency: localStorage.getItem('currency') ?? 'aed',
                lang: "en",
                business_id,
                business_user_id,
                coupon: coupon,
                business_type
            })

            if (response?.data?.success) {
                const data = response?.data?.data?.items;

                const index = data?.findIndex(item => item.item_number === item_number);

                if (index !== -1) {
                    return Number(data[index].item_qty);
                } else {
                    return 0;
                }
            } else {
                return 0;
            }


        } catch (error) {
            console.log(error);
        }
    }

    const GetFavourateCartItemQty = async (item_number, type) => {
        try {
            const response = await axiosGet(`/Orders/GetExcludeVatCarts`, {
                currency: localStorage.getItem('currency') ?? 'aed',
                lang: "en",
                business_id,
                business_user_id,
                coupon,
                business_type
            });

            if (response?.data?.success) {
                const data = response?.data?.data?.items || [];

                const index = data.findIndex(item => {
                    if (type === "Favourite") {
                        return item.item_number.replace(/[^a-zA-Z0-9]/g, '') ===
                            item_number.replace(/[^a-zA-Z0-9]/g, '');
                    } else {
                        return item.item_number === item_number;
                    }
                });

                if (index > -1) {
                    return {
                        qty: Number(data[index].item_qty),
                        part_number: data[index].item_number
                    };
                } else {
                    return {
                        qty: 0,
                        part_number: null
                    };
                }
            } else {
                return {
                    qty: 0,
                    part_number: null
                };
            }

        } catch (error) {
            console.log("GetCartItemDetails error:", error);
            return {
                qty: 0,
                part_number: null
            };
        }
    };

    const AddToFavorite = async (data) => {
        try {

            const response = await axiosPost(`/Users/AddFavorite`, data);

            if (response?.data?.success) {
                setIsFavUpdate(prev => !prev);
            } else {
                toast.error(data.message || "Failed to add to favorites.");
            }

        } catch (error) {
            console.log(error)
        }
    }

    const GetFavorites = async () => {
        try {
            const response = await axiosGet(
                `/Users/GetFavorites`,
                {
                    business_id,
                    business_user_id
                }
            );
            if (response?.data?.success) {
                setFavItems(response?.data?.data);
                setFavItemsQty(response?.data?.data?.length);
            }

        } catch (error) {
            console.error("Error fetching favorites:", error);
        }
    };

    const RemoveToFavorite = async (part, type) => {
        try {

            let foundItem;

            if (type === "Oil") {
                foundItem = FavItems?.find(item =>
                    (item.item_number || "").replaceAll(/\s/g, '') === (part?.stock_number || "").replaceAll(/\s/g, '') &&
                    item?.item_brand_name === part?.stock_brand_name
                );
            } else {
                foundItem = FavItems?.find(item =>
                    (item.item_number || "").replaceAll(/\s/g, '') === (part?.ART_SEARCH_NUMBER || "").replaceAll(/\s/g, '') &&
                    item?.item_brand_name === part?.stock_brand_name
                );
            }

            // ✅ Safety check
            if (!foundItem) {
                console.warn("Item not found in favorites");
                return;
            }

            const { favorite_id } = foundItem;

            const response = await axiosPost(`/Users/DeleteFavorite`, { favorite_id });

            if (response?.data?.success) {
                setIsFavUpdate(prev => !prev);
            }

        } catch (error) {
            console.error("Error removing favorite:", error);
        }
    };




    const GetStockPolicyItem = async (
        part_number,
        stock_type,
        stock_sup_id,
        stock_brand_name
    ) => {
        try {
            const response = await axiosGet(`/Orders/GetStockPolicyItem`, {
                part_number,
                stock_type,
                stock_sup_id,
                stock_brand_name,
            });

            if (response?.data?.success) {
                return response.data.data;
            }

            return null;
        } catch (error) {
            console.log("GetStockPolicyItem Error:", error);
            return null;
        }
    };




    useEffect(() => {
        GetFavorites();
    }, [isFavUpdate])

    useEffect(() => {
        GetCartsData()
    }, [isCartUpdate])

    let values = {
        cartItems,
        cartLoading,
        cartData,
        setCoupon,
        coupon,
        QtyUpdate,
        GetCartItemQty,
        DeleteCartItem,
        AddToCart,
        loadings,
        AddToFavorite,
        RemoveToFavorite,
        GetFavourateCartItemQty,

        sub_total_display,
        vat_amount_display,


        GetStockPolicyItem
    }

    return (
        <CartsContext.Provider value={values}>
            {children}
        </CartsContext.Provider>
    )
}